var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('DashboardNavbar'),_c('div',{staticClass:"app-content pagination-with-content"},[_c('UserSettingsTabs',{key:_vm.userTypeTokenData,attrs:{"userTypeToken":_vm.userTypeTokenData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }